import { UniButton } from '@/design-system/components/buttons';
import { UniIconButton } from '@/design-system/components/buttons';
import { TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { CancelCardStackParamList, CancelCardStackRoutes } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import { Dropdown } from '@/design-system/components/dropdown';
import { CardCancelReasonFilters } from '../../options';

export interface CancelCardProps {
  onClose: () => void;
  onLayout: (event: any) => void;
  onData: (data: any) => void;
  account: string;
  tab?: number;
  record?: any;
  func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
  onReturnData?: (data: any) => void;
  refresh?: () => void;
}

export const CancelCardNativeZeroScreen: React.FC<CancelCardProps> = (props) => {
  const { onClose, onLayout, onData, account, tab, record, func, onReturnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const { body, textMb, btnView, btn } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<CancelCardStackParamList>>();

  const [dt, setDt] = useState<any>({
    reason: 'lost',
    cardAccountId: account,
    cardId: record?.id
  });
  const [errorMsg, setErrorMsg] = useState<any>({
    reason: undefined
  });

  const changeCancelCard = () => {
    let validate = true;

    if (validate) {
      onData({ data: dt });
      navigation.navigate(CancelCardStackRoutes.Confirm, { onLayout, data: dt, account, tab, record, func, onReturnData, refresh });
    }
  };

  const { theme } = useDripsyTheme();

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <View sx={{ px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ position: 'absolute', top: 0, left: 12, zIndex: 2 }}>
            <UniIconButton
              icon="arrowLeft"
              options={{ iconStyles: { color: theme?.colors?.$white as string } }}
              onPress={onClose}></UniIconButton>
          </View>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('credit-card-cancel-card::glossary.cancel-card')}
            </TextTitle>
          </View>
        </View>
      </PageHeaderModalNative>
      <View sx={body}>
        <TextTitle sx={textMb} semiBold>
          {t('credit-card-cancel-card::cancel-card-form.text--please-select-reason')}
        </TextTitle>
        <View sx={{ gap: '$5' }}>
          <View sx={{ zIndex: 99 }}>
            <Dropdown
              value={dt.reason}
              label={t('credit-card-cancel-card::glossary.reason')}
              options={CardCancelReasonFilters(t)}
              sx={{ width: '100%' }}
              onValueChange={(value) => {
                setDt({
                  ...dt,
                  reason: value
                });
              }}
            />
          </View>
        </View>
        <View sx={btnView}>
          <UniButton
            sx={btn}
            labelSx={{ color: '$balck' }}
            label={t('credit-card-cancel-card::glossary.cancel-card')}
            onPress={changeCancelCard}
          />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  body: {
    px: 16,
    py: 20
  },
  textMb: {
    marginBottom: 20
  },
  btnView: {
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  },
  btn: {
    width: '100%',
    height: 44
  }
};
